export default {"src":"/_next/static/media/javascript.b472cbc1.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};